function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { unstable_composeClasses as composeClasses, unstable_useId as useId } from '@mui/utils';
import { fastMemo } from '@mui/x-internals/fastMemo';
import { useRtl } from '@mui/system/RtlProvider';
import { useGridPrivateApiContext } from "../../hooks/utils/useGridPrivateApiContext.js";
import { ColumnHeaderMenuIcon } from "./ColumnHeaderMenuIcon.js";
import { GridColumnHeaderMenu } from "../menu/columnMenu/GridColumnHeaderMenu.js";
import { gridClasses, getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { GridGenericColumnHeaderItem } from "./GridGenericColumnHeaderItem.js";
import { isEventTargetInPortal } from "../../utils/domUtils.js";
import { PinnedColumnPosition } from "../../internals/constants.js";
import { attachPinnedStyle } from "../../internals/utils/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var colDef = ownerState.colDef, classes = ownerState.classes, isDragging = ownerState.isDragging, sortDirection = ownerState.sortDirection, showRightBorder = ownerState.showRightBorder, showLeftBorder = ownerState.showLeftBorder, filterItemsCounter = ownerState.filterItemsCounter, pinnedPosition = ownerState.pinnedPosition, isLastUnpinned = ownerState.isLastUnpinned, isSiblingFocused = ownerState.isSiblingFocused;
    var isColumnSorted = sortDirection != null;
    var isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    var isColumnNumeric = colDef.type === 'number';
    var slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === PinnedColumnPosition.LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === PinnedColumnPosition.RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isLastUnpinned && 'columnHeader--lastUnpinned',
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderItem(props) {
    var _rootProps_slotProps, _rootProps_slotProps1, _rootProps_slotProps2;
    var colDef = props.colDef, columnMenuOpen = props.columnMenuOpen, colIndex = props.colIndex, headerHeight = props.headerHeight, isResizing = props.isResizing, isLast = props.isLast, sortDirection = props.sortDirection, sortIndex = props.sortIndex, filterItemsCounter = props.filterItemsCounter, hasFocus = props.hasFocus, tabIndex = props.tabIndex, disableReorder = props.disableReorder, separatorSide = props.separatorSide, showLeftBorder = props.showLeftBorder, showRightBorder = props.showRightBorder, pinnedPosition = props.pinnedPosition, pinnedOffset = props.pinnedOffset;
    var apiRef = useGridPrivateApiContext();
    var rootProps = useGridRootProps();
    var isRtl = useRtl();
    var headerCellRef = React.useRef(null);
    var columnMenuId = useId();
    var columnMenuButtonId = useId();
    var iconButtonRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(columnMenuOpen), 2), showColumnMenuIcon = _React_useState[0], setShowColumnMenuIcon = _React_useState[1];
    var isDraggable = React.useMemo(function() {
        return !rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder;
    }, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    var headerComponent;
    if (colDef.renderHeader) {
        headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    }
    var ownerState = _extends({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    var classes = useUtilityClasses(ownerState);
    var publish = React.useCallback(function(eventName) {
        return function(event) {
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if (isEventTargetInPortal(event)) {
                return;
            }
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        };
    }, [
        apiRef,
        colDef.field
    ]);
    var mouseEventsHandlers = React.useMemo(function() {
        return {
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        };
    }, [
        publish
    ]);
    var draggableEventHandlers = React.useMemo(function() {
        return isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {};
    }, [
        isDraggable,
        publish
    ]);
    var columnHeaderSeparatorProps = React.useMemo(function() {
        return {
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        };
    }, [
        publish
    ]);
    React.useEffect(function() {
        if (!showColumnMenuIcon) {
            setShowColumnMenuIcon(columnMenuOpen);
        }
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    var handleExited = React.useCallback(function() {
        setShowColumnMenuIcon(false);
    }, []);
    var columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ _jsx(ColumnHeaderMenuIcon, {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    var columnMenu = /*#__PURE__*/ _jsx(GridColumnHeaderMenu, {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.columnMenu,
        onExited: handleExited
    });
    var _colDef_sortingOrder;
    var sortingOrder = (_colDef_sortingOrder = colDef.sortingOrder) !== null && _colDef_sortingOrder !== void 0 ? _colDef_sortingOrder : rootProps.sortingOrder;
    var showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    var columnTitleIconButtons = /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ _jsx(rootProps.slots.columnHeaderFilterIconButton, _extends({
                field: colDef.field,
                counter: filterItemsCounter
            }, (_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ _jsx(rootProps.slots.columnHeaderSortIcon, _extends({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, (_rootProps_slotProps2 = rootProps.slotProps) === null || _rootProps_slotProps2 === void 0 ? void 0 : _rootProps_slotProps2.columnHeaderSortIcon))
        ]
    });
    React.useLayoutEffect(function() {
        var columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            var _apiRef_current_columnHeadersContainerRef;
            var focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            var elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus === null || elementToFocus === void 0 ? void 0 : elementToFocus.focus();
            if ((_apiRef_current_columnHeadersContainerRef = apiRef.current.columnHeadersContainerRef) === null || _apiRef_current_columnHeadersContainerRef === void 0 ? void 0 : _apiRef_current_columnHeadersContainerRef.current) {
                apiRef.current.columnHeadersContainerRef.current.scrollLeft = 0;
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    var headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    var _colDef_headerName;
    var label = (_colDef_headerName = colDef.headerName) !== null && _colDef_headerName !== void 0 ? _colDef_headerName : colDef.field;
    var style = React.useMemo(function() {
        return attachPinnedStyle(_extends({}, props.style), isRtl, pinnedPosition, pinnedOffset);
    }, [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ _jsx(GridGenericColumnHeaderItem, _extends({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: clsx(headerClassName, isLast && gridClasses['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderItem.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    colDef: PropTypes.object.isRequired,
    colIndex: PropTypes.number.isRequired,
    columnMenuOpen: PropTypes.bool.isRequired,
    disableReorder: PropTypes.bool,
    filterItemsCounter: PropTypes.number,
    hasFocus: PropTypes.bool,
    headerHeight: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    isLast: PropTypes.bool.isRequired,
    isLastUnpinned: PropTypes.bool.isRequired,
    isResizing: PropTypes.bool.isRequired,
    isSiblingFocused: PropTypes.bool.isRequired,
    pinnedOffset: PropTypes.number,
    pinnedPosition: PropTypes.oneOf([
        0,
        1,
        2,
        3
    ]),
    separatorSide: PropTypes.oneOf([
        'left',
        'right'
    ]),
    showLeftBorder: PropTypes.bool.isRequired,
    showRightBorder: PropTypes.bool.isRequired,
    sortDirection: PropTypes.oneOf([
        'asc',
        'desc'
    ]),
    sortIndex: PropTypes.number,
    style: PropTypes.object,
    tabIndex: PropTypes.oneOf([
        -1,
        0
    ]).isRequired
} : void 0;
var Memoized = fastMemo(GridColumnHeaderItem);
export { Memoized as GridColumnHeaderItem };
